export default __webpack_public_path__ + "static/media/OrderStatus_5.a561f55c.svg";